import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";

export function useChildMappingsByAssetIds(parentAssetIds: number[]) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["childMappingsByAssetIds", parentAssetIds],
    queryFn: async () => apiContext.hvSubstationApis.getChildMappingsByAssetIds(parentAssetIds),
  });
}
